import { ListenerEvent as PackageListenerEvent } from '@carvana/merch-native';

enum FinanceListenerEvent {}

export const ListenerEvent = {
  ...FinanceListenerEvent,
  ...PackageListenerEvent
};

export type ListenerEventType = FinanceListenerEvent | PackageListenerEvent;
